export class CatalogMenu {
	catalogMenuSelector = '#catalog-menu';
	catalogOpenerSelector = '.js-catalog-opener';
	modalLayerSelector = '.js-modal-layer';
	activeClass = 'catalog-opener--active';
	modalLayerClass = 'modal-layer--catalog';
	modalLayerClosingClass = 'modal-layer--closing';
	modalLayerClosingTimeout = 400;

	constructor(element) {
		if (!element) return;
		this.catalogMenu = element;

		this.init();
	}

	init() {
		this.catalogOpeners = document.querySelectorAll(this.catalogOpenerSelector);
		this.modalLayer = document.querySelector(this.modalLayerSelector);

		this.bindEvents();
	}

	handleMenuButtonClick = (button, e) => {
		e.preventDefault();
		if (!button.classList.contains(this.activeClass)) {
			window.app.modal.open(this.catalogMenuSelector);
		} else {
			window.app.modal.close();
		}
	};

	handleModalOpen = () => {
		this.catalogOpeners.forEach((opener) => opener.classList.add(this.activeClass));
		this.modalLayer?.classList.add(this.modalLayerClass);
	};

	handleModalClose = () => {
		this.catalogOpeners.forEach((opener) => opener.classList.remove(this.activeClass));
		this.modalLayer?.classList.add(this.modalLayerClosingClass);
		setTimeout(() => {
			this.modalLayer?.classList.remove(this.modalLayerClass, this.modalLayerClosingClass);
		}, this.modalLayerClosingTimeout);
	};

	bindEvents() {
		this.catalogOpeners.forEach((opener) => {
			opener.addEventListener('click', (e) => this.handleMenuButtonClick(opener, e));
		});

		this.catalogMenu?.addEventListener('modalOpen', this.handleModalOpen);
		this.catalogMenu?.addEventListener('modalClose', this.handleModalClose);
	}
}
